export const replaceCategory = slug => {
	const sectionsToReplace = /cuidadores\/|mujeres\/|hombres\//gim
	return slug.replace(sectionsToReplace, '').replace(/\/\//gim, '/')
}
